/* eslint-disable */
import React, { useState } from "react";
import { Table, Group, Text, Box, Button } from "@mantine/core";
import { Trash } from "tabler-icons-react";
import { useGetHolidays } from "api/holiday/getHoliday";
import { getWeekdayName } from "utils/dateConvertIntoDayWeek";
import { useDeleteHoliday } from "api/holiday/deleteHoliday";
import { PermissionActionIcon } from "api/permission/permissionActionBtn";
import { IconPencil } from "@tabler/icons-react";
import { TimeZoneDate } from "utils/timezoneDate";
import { toSafeDate } from "utils/dateGuards";
import DeleteConfirmationModal from "./canfirmationmodal/confirmationModal";

export default function HolidayTable() {
  const { data } = useGetHolidays();
  const { mutate: deleteHoliday, isLoading: isDeleting } = useDeleteHoliday();

  const [opened, setOpened] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const openDeleteModal = (id: any) => {
    setSelectedId(id);
    setOpened(true);
  };

  const handleDeleteConfirm = () => {
    if (!selectedId) return;
    deleteHoliday(selectedId, {
      onSuccess: () => {
        setOpened(false);
        setSelectedId(null);
      },
      onError: (err) => {
        console.error("Failed to delete holiday:", err);
        setOpened(false);
        setSelectedId(null);
      },
    });
  };

  return (
    <Box
      style={{ backgroundColor: "#fff", padding: "20px", borderRadius: "8px" }}
    >
      <div>
        <Table verticalSpacing="sm" highlightOnHover>
          <thead
            style={{
              backgroundColor: "#f5f5f5",
            }}
          >
            <tr>
              <th>
                <Text weight={500}>Holiday Day</Text>
              </th>
              <th style={{ cursor: "pointer" }}>
                <Group spacing={4} align="center">
                  <Text weight={500}>Holiday Date</Text>
                </Group>
              </th>
              <th>
                <Text weight={500}>Holiday Name</Text>
              </th>
              <th style={{ width: 120 }}>
                <Text weight={500}>Action</Text>
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.data?.map((h: any, idx: any) => (
              <tr key={h?._id}>
                <td>
                  <Text color={idx % 2 === 0 ? "red" : "green"}>
                    {toSafeDate(h?.date) ? getWeekdayName(h?.date) : "-"}
                  </Text>
                </td>
                <td>
                  <Text color={idx % 2 === 0 ? "red" : "green"}>
                    {toSafeDate(h?.date) ? TimeZoneDate(h?.date) : "-"}
                  </Text>
                </td>
                <td>
                  <Text color="green">{h?.title}</Text>
                </td>
                <td>
                  <Group spacing="xs">
                    <PermissionActionIcon
                      permission="holiday_managment.update"
                      variant="transparent"
                    >
                      <IconPencil size={16} />
                    </PermissionActionIcon>

                    <PermissionActionIcon
                      permission="holiday_managment.delete"
                      variant="transparent"
                      onClick={() => openDeleteModal(h?._id)}
                    >
                      <Trash size={16} />
                    </PermissionActionIcon>
                  </Group>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      <DeleteConfirmationModal
        opened={opened}
        onClose={() => {
          setOpened(false);
          setSelectedId(null);
        }}
        onConfirm={handleDeleteConfirm}
        isLoading={isDeleting}
      />
    </Box>
  );
}
